module.exports = __webpack_public_path__ + "img/pink-arrow.168ec12f.svg";